import type { SingleTicketDto } from '@hcr/api/consumer'

export const isSingleTicketIdIn =
  (ticketsIds: number[]) =>
  (ticket: SingleTicketDto): boolean =>
    ticketsIds.includes(ticket.ticket_id)
